import { render, staticRenderFns } from "./SafetyTable.vue?vue&type=template&id=221a0249&scoped=true"
import script from "./SafetyTable.vue?vue&type=script&lang=js"
export * from "./SafetyTable.vue?vue&type=script&lang=js"
import style0 from "./SafetyTable.vue?vue&type=style&index=0&id=221a0249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221a0249",
  null
  
)

export default component.exports